import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Modal, Button } from "react-bootstrap";
import { getReviewButtonProps } from "../../utils/reviewButtonProps";
import { useNavigate, Link } from "react-router-dom";

const ReviewButton = ({ item, handleAiReview, loading }) => {
  const { icon, color, title, disabled } = getReviewButtonProps(item);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const onClick = () => {
    const { reviewStatus, status } = item;
    if (
      ["approved", "rejected"].includes(reviewStatus) ||
      ["ai_approved", "ai_rejected"].includes(status)
    ) {
      setShowModal(true);
    } else if (
      ["pending_ai_review"].includes(status) ||
      reviewStatus === "pending"
    ) {
      handleAiReview(item);
    }
  };

  const handleEdit = () => {
    navigate(`/vault-questions/edit-vault-question/${item._id}`);
  };

  const handleReRun = () => {
    handleAiReview(item);
    setShowModal(false);
  };

  const isRejected =
    ["rejected", "ai_rejected"].includes(item.reviewStatus) ||
    ["rejected", "ai_rejected"].includes(item.status);

  const isApproved =
    ["approved", "ai_approved"].includes(item.reviewStatus) ||
    ["approved", "ai_approved"].includes(item.status);

  return (
    <>
      <button
        onClick={onClick}
        disabled={loading || disabled}
        title={title}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          border: "none",
          background: "transparent",
        }}
      >
        <Icon icon={icon} width={24} height={24} color={color} />
      </button>

      {/* ✅ Bootstrap Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-confirmation-modal"
      >
        <Modal.Body className="text-center p-4">
          <div className="mb-3">
            <Icon
              icon={
                isApproved
                  ? "mdi:check-circle-outline"
                  : "mdi:alert-circle-outline"
              }
              width={100}
              height={100}
              color={isApproved ? "#4caf50" : "#f8bb86"}
            />
          
          </div>
          <h5 className="mb-2 swal2-title">
            {isApproved ? "Already Approved ✅" : "AI Rejected ❌"}
          </h5>
          <p className="swal2-html-container mb-4">
            {isApproved
              ? "This question has already been reviewed and approved."
              : "This question was rejected by AI. You can edit and resubmit."}
          </p>

          <div className="d-flex justify-content-center gap-2"
            style={{ marginTop: "30px" }}
          >
            <Button variant="secondary" className="px-10 py-10" onClick={() => setShowModal(false)}>
              Cancel
            </Button>

            {isRejected && (
              <>
                <Button variant="secondary" className="px-10 py-10" onClick={handleEdit}>
                  Edit Question
                </Button>
                <Button variant="primary" className="px-10 py-10" onClick={handleReRun}>
                  Re-run AI Review
                </Button>
              </>
            )}

            {isApproved && (
              <Button variant="primary"  className="px-10 py-10" onClick={handleReRun}>
                Override & Re-run
              </Button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ReviewButton;
